import Vue from 'vue'
import App from './App.vue'
import store from './store/store.js'
import { storageService } from "./services/StorageService.js"
import { cordovaInit } from "./services/CordovaInit.js"
//import fastclick from 'vue-fastclick';
import router from './routes'
import i18n from './language.js'

// eslint-disable-next-line
import fonts from './fontAwesome.js';

// load additional css
/* 
!!!!!CUSTOM BOOTSRTAP GRID using grid / grid-* ipv container / container-* 
container is often used in vue for wrapping custom elements..
*/

require('./assets/bootstrap-custom-grid.css');


// enable gestures
import Vue2TouchEvents from 'vue2-touch-events'
Vue.use(Vue2TouchEvents)




initStorage();

cordovaInit.init().then(
  () => { 
    initStorage();
   },
  () => {console.log("error: cordova failed")}
)


// init local database
function initStorage(){
  storageService.ready().then(
    () => { createApp() },
    () => { alert ("error with local database") }
  )
}


function createApp(){

  Vue.config.productionTip = false

  new Vue({
    render: h => h(App),
    store,
    router,
    i18n,
  }).$mount('#app')
}




